export default __webpack_public_path__ + "485722eeb7a4fa1d8c261b2a63a18cd0.png";